let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8NlQy")).then(() => parcelRequire('iqmbF'));